export const envConfigs = {
    production: {
        apiUrl: 'https://api.hummingbirdtech.com',
        gqlGatewayUrl: 'https://farm-api.hummingbirdtech.com',
        bucketUrl: 'https://www.googleapis.com/upload/storage/v1/b/hummingbirdtech-production-raw/o?uploadType=resumable',
        analysisTileUrl: 'https://storage.googleapis.com/hummingbirdtech-production-maps',
        googleMapsApiKey: 'AIzaSyCODSR5yZwK0U3GZq8siANHhF6cfMAGytE',
        accountsUrl: 'https://accounts.hummingbirdtech.com/',
        appUrl: 'https://app.hummingbirdtech.com/',
        adminUrl: 'https://admin.hummingbirdtech.com/',
        applicationUrl: 'https://applications.hummingbirdtech.com/',
        uploaderUrl: 'https://uploader.hummingbirdtech.com/',
        downloadApplicationFileReportSheetUrl: 'https://script.google.com/macros/s/AKfycbxjq3VIgzC3ZSHLazInjbR5PW9Wn8su75ZblmbMqlUUwNORskFj/exec',
        adminSlackBotUrl: 'https://europe-west1-hummingbirdtech-production.cloudfunctions.net/admin-slack-bot',
        slackChannelApplicationFileDownload: 'C0218BZ5J10',
        gaTrackingCode: 'UA-159160386-1',
        bucket: 'hummingbirdtech-production-raw',
        indexedDBName: 'HummingbirdUploaderStore',
    },
    staging: {
        apiUrl: 'https://api.stg.hummingbirdtech.com',
        gqlGatewayUrl: 'https://farm-api.stg.hummingbirdtech.com',
        bucketUrl: 'https://www.googleapis.com/upload/storage/v1/b/hbt-staging-ortho-raw/o?uploadType=resumable',
        analysisTileUrl: 'https://storage.googleapis.com/hbt-staging-maps',
        accountsUrl: 'https://accounts.staging.hummingbirdtech.com/',
        appUrl: 'https://app.staging.hummingbirdtech.com/',
        adminUrl: 'https://admin.staging.hummingbirdtech.com/',
        applicationUrl: 'https://applications.staging.hummingbirdtech.com/',
        uploaderUrl: 'https://uploader.staging.hummingbirdtech.com/',
        downloadApplicationFileReportSheetUrl: 'https://script.google.com/a/hummingbirdtech.com/macros/s/AKfycbzNAzDGfS98zI-gLTxcCTPuVeg6rn2hGdtL2tkM/exec',
        adminSlackBotUrl: 'https://europe-west1-hummingbirdtech-production.cloudfunctions.net/admin-slack-bot',
        slackChannelApplicationFileDownload: 'C02114XCWS2',
        gaTrackingCode: '',
        bucket: 'hbt-staging-ortho-raw',
        indexedDBName: 'HummingbirdUploaderStore',
    },
};
//# sourceMappingURL=config.js.map